import { jsxs as B, Fragment as E, jsx as e } from "react/jsx-runtime";
import { useEffect as L } from "react";
import { useDndContext as N, DragOverlay as R } from "@dnd-kit/core";
import S from "../../../helpers/preloadImages.js";
import { templatesIcons as j } from "../../../data/mock.js";
import y from "./ExplorerListItem/ExplorerListItem.js";
import k from "./ExplorerListItem/ExplorerListItemSkelet.js";
import z from "./DropItem/index.js";
const A = "forma-filling__explorer-list__draggable", Y = "forma-filling__explorer-list__dropContainer", O = {
  draggable: A,
  dropContainer: Y
}, $ = 60, w = (t, n) => {
  for (const r of t) {
    if (r.id === n)
      return r;
    if (r.children) {
      const i = w(r.children, n);
      if (i)
        return i;
    }
  }
  return null;
}, V = ({
  foldersTree: t,
  active: n,
  updated: r,
  selected: i,
  isLoading: D,
  onToggleMenu: m,
  isModalOpen: s,
  editing: c,
  actions: d,
  optionsState: f,
  showEmptyText: p,
  isInGroup: F,
  contextMenu: g
}) => {
  var u, x;
  const l = N(), _ = t && w(t, (x = (u = l.active) == null ? void 0 : u.data.current) == null ? void 0 : x.id);
  return L(() => {
    S([
      ...Object.values(j.list.folders),
      ...Object.values(j.list.files)
    ]);
  }, []), L(() => {
    r && setTimeout(() => {
      const o = document.getElementById(`file_explorer_template_${r}`);
      o && window.scrollTo({ top: window.scrollY + o.getBoundingClientRect().top - $, behavior: "smooth" });
    }, 200);
  }, [r]), /* @__PURE__ */ B(E, { children: [
    D ? [...Array(10)].map((o, a) => /* @__PURE__ */ e(k, {}, a)) : /* @__PURE__ */ e(
      z,
      {
        id: null,
        dropId: "root",
        name: "",
        type: "folder",
        className: O.dropContainer,
        children: /* @__PURE__ */ e(E, { children: t == null ? void 0 : t.map((o) => {
          var a, I, v, C, b, h;
          return /* @__PURE__ */ e(
            y,
            {
              item: o,
              active: n,
              updated: r,
              selected: i,
              over: ((I = (a = l.over) == null ? void 0 : a.data.current) == null ? void 0 : I.id) !== ((C = (v = l.active) == null ? void 0 : v.data.current) == null ? void 0 : C.folderId) && ((h = (b = l.over) == null ? void 0 : b.data.current) == null ? void 0 : h.id),
              optionsState: f,
              onToggleMenu: m,
              isModalOpen: s,
              editing: c,
              actions: d,
              showEmptyText: p,
              isInGroup: F,
              contextMenu: g
            },
            o.id
          );
        }) })
      }
    ),
    /* @__PURE__ */ e(R, { zIndex: 10, children: !!_ && /* @__PURE__ */ e(
      y,
      {
        item: _,
        updated: r,
        selected: i,
        optionsState: f,
        onToggleMenu: m,
        isModalOpen: s,
        editing: c,
        actions: d,
        className: O.draggable,
        showEmptyText: p,
        contextMenu: g
      }
    ) })
  ] });
};
export {
  V as default
};
